module.exports = __webpack_public_path__ + "static/media/06.37621384.jpg";